import 'reflect-metadata';

import './app/di/di.app';
import './main.css';

import * as ReactDOM from 'react-dom/client';
import ContainerApp from './app/container/container.app';
import envConfig from './configs/env/env.config';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

async function deferRender() {
  if (envConfig.env !== 'development' || envConfig.apiBaseUrl !== '') return;

  const browser = (await import('./mocks/browser.mock')).default;
  browser.start();
}

deferRender().then(() => root.render(<ContainerApp />));
